/* istanbul ignore file */

import React, { useEffect, useMemo, useState } from 'react';
import { isBreakpointMediumOrAbove, useBreakpoint } from '@noths/polaris-client-ribbons-base';
import type { DrawerProps } from '@noths/polaris-client-ribbons-design-system';
import { Drawer } from '@noths/polaris-client-ribbons-design-system';

import { DepartmentsNav } from 'client-site-chrome-ui/components/molecules/DepartmentsNav/DepartmentsNav';
import { NavigationDrilldown } from 'client-site-chrome-ui/components/molecules/NavigationDrilldown/components/NavigationDrilldown';
import { transformToDepartmentsProp } from 'client-site-chrome-ui/components/organisms/Navigation/transformToDepartmentsProp';
import { transformToDrilldownProp } from 'client-site-chrome-ui/components/organisms/Navigation/transformToDrilldownProp';
import type { CommonNavContent } from 'client-site-chrome-ui/content/types/commonNavigation';
import { useSiteChromeDynamicContext } from 'client-site-chrome-ui/context/SiteChromeDynamicContext/useSiteChromeDynamicContext';

export interface NavigationProps {
  content: CommonNavContent;
}

export const Navigation = ({ content }: NavigationProps) => {
  const { navigationModal } = useSiteChromeDynamicContext();
  const onClose = () => navigationModal?.close();
  const breakpoint = useBreakpoint({ initializeWithLarge: true });
  const isMediumScreenOrAbove = isBreakpointMediumOrAbove(breakpoint);
  const [drawerSize, setDrawerSize] = useState<DrawerProps['panelSize']>('partial');
  const departmentsNav = useMemo(() => {
    return transformToDepartmentsProp(content);
  }, [content]);

  const drilldownNav = useMemo(() => {
    return transformToDrilldownProp(content);
  }, [content]);

  useEffect(() => {
    setDrawerSize(isMediumScreenOrAbove ? 'partial' : 'full');
  }, [isMediumScreenOrAbove]);

  return (
    <>
      <DepartmentsNav departments={departmentsNav} />
      <Drawer
        contentLabel="Navigation"
        isOpen={!!navigationModal?.isOpen}
        onRequestClose={onClose}
        panelSize={drawerSize}
        transitionFrom="right"
      >
        <NavigationDrilldown navigation={drilldownNav} onClose={onClose} />
      </Drawer>
    </>
  );
};
